import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "../../../styles/admin_user_nav.css";
import {
  AnswerKeyDataForApprovalByEntityId,
  DuplicateApprovalEntityRequest,
} from "../../actions/postExaminationProcessObjectiveActions";
import label from "../../labels/postExaminationProcessObjective_en.json";
import clabel from "../../../common/labels/common_en.json";

const DuplicateApprovalEntity = (props) => {
  const [allAnswerValues, setAllAnswerValues] = useState([]);
  let [selectedEntity, setSelectedEntity] = useState();
  const labels = Array.from({ length: 7 }, (_, index) => `Booklet / Sheet No`);

  const { register, handleSubmit, formState, watch } = useForm({
    mode: "onChange",
  });

  const dispatch = useDispatch();

  let { answerKeyDataForApproval } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  useEffect(() => {
    if (props.setSelectedApprovalEntity) {
      setSelectedEntity(props.setSelectedApprovalEntity);
    }
  }, [props.setSelectedApprovalEntity]);

  useEffect(() => {
    if (selectedEntity) {
      const entityId = selectedEntity.entityApprovalAction.entityApprovalDto.id;
      //   dispatch(AnswerKeyDataForApprovalByEntityId(entityId));
    }
  }, [dispatch, selectedEntity]);

  useEffect(() => {
    if (
      props.setSelectedApprovalEntity &&
      props.setSelectedApprovalEntity.entityApprovalAction.entityApprovalDto
        .detail &&
      props.setSelectedApprovalEntity.entityApprovalAction.entityApprovalDto
        .detail.duplicates
    ) {
      setAllAnswerValues(
        props.setSelectedApprovalEntity.entityApprovalAction.entityApprovalDto
          .detail.duplicates
      );
      
    }else{
      if(props.setSelectedApprovalEntity.entityApprovalAction.entityApprovalDto
        .detail.subjectType=="descriptive"){
        setAllAnswerValues(
          props.setSelectedApprovalEntity.entityApprovalAction.entityApprovalDto
            .detail.descriptiveDuplicates
        );
      }else{
        setAllAnswerValues(
          props.setSelectedApprovalEntity.entityApprovalAction.entityApprovalDto
            .detail.duplicates
        );
      }
    }
  }, [selectedEntity]);

  const onSubmit = (data) => {
    let requestData = selectedEntity;
    if (requestData) {
      requestData.entityApprovalAction.action = data.statustype;
      requestData.entityApprovalAction.comments = data.comment.trim();
      requestData.entityApprovalAction.entityApprovalDto.detail =
        JSON.stringify(
          requestData.entityApprovalAction.entityApprovalDto.detail
        );
      let requestBody = {
        entityApprovalDto: {
          entityMaster:
            requestData.entityApprovalAction.entityApprovalDto.entityMaster,
          entityApproval: requestData.entityApprovalAction.entityApprovalDto,
          entityApprovalAction: selectedEntity.entityApprovalAction,
        },
      };

      dispatch(DuplicateApprovalEntityRequest(requestBody, props.setShowModal));
      let details = JSON.parse(
        selectedEntity.entityApprovalAction.entityApprovalDto.detail
      );
      selectedEntity.entityApprovalAction.entityApprovalDto.detail = details;
      setSelectedEntity(selectedEntity);
    }
  };

  return (
    <Modal
      size="xl"
      show={props.showModal}
      onHide={() => {
        props.setShowModal(false);
      }}
      aria-labelledby="example-modal-sizes-title-xl"
      backdrop="static"
    >
      <form>
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-xl">
            {(selectedEntity &&
              selectedEntity.entityApprovalAction &&
              selectedEntity.entityApprovalAction.entityApprovalDto &&
              selectedEntity.entityApprovalAction.entityApprovalDto
                .entityMaster &&
              selectedEntity.entityApprovalAction.entityApprovalDto.entityMaster
                .name == "duplicate") ||
            "objective"
              ? "Duplicate Roll no "
              : ""}
            {label.APPROVAL} (
            {selectedEntity &&
            selectedEntity.entityApprovalAction &&
            selectedEntity.entityApprovalAction.level == 1
              ? label.APPROVAL_LEVEL_1_PENDING
              : ""}
            {selectedEntity &&
            selectedEntity.entityApprovalAction &&
            selectedEntity.entityApprovalAction.level == 2
              ? label.APPROVAL_LEVEL_2_PENDING
              : ""}
            {selectedEntity &&
            selectedEntity.entityApprovalAction &&
            selectedEntity.entityApprovalAction.level == 3
              ? label.APPROVAL_LEVEL_3_PENDING
              : ""}
            )
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-8">
              {selectedEntity &&
              selectedEntity.entityApprovalAction &&
              selectedEntity.entityApprovalAction.entityApprovalDto &&
              selectedEntity.entityApprovalAction.entityApprovalDto
                .entityMaster &&
              (selectedEntity.entityApprovalAction.entityApprovalDto
                .entityMaster.name == "duplicate" ||
                "objective") ? (
                <div className="VenueSection">
                  <div className="row custom-padding">
                    <div className="form-group col-md-1.5">
                      <label className="LeftText bold-label">
                        {label.EXAM_NAME}
                      </label>
                    </div>
                    <div className="form-group col-md-5">
                      <label className="LeftText">
                        {selectedEntity &&
                          selectedEntity.entityApprovalAction.entityApprovalDto
                            .detail.examName}{" "}
                      </label>
                    </div>
                    <div className="form-group col-md-1.5">
                      <label className="LeftText bold-label">
                        {label.SUBJECT_NAME}
                      </label>
                    </div>
                    <div className="form-group col-md-3">
                      <label className="LeftText">
                        {selectedEntity &&
                          selectedEntity.entityApprovalAction.entityApprovalDto
                            .detail.subjectName}{" "}
                        <br />{" "}
                      </label>
                    </div>
                  </div>

                  <div>
                    <table className="table text-center">
                      <thead className="bold-label">
                        <tr>
                          <th id="bordered">{label.CenterName}</th>
                          <th id="bordered">{label.BookLetNo}</th>
                          <th id="bordered">{label.sheetNo}</th>
                          <th id="bordered">{label.PreviousRollNo}</th>
                          <th id="bordered">{label.CorrectedRollNo}</th>
                        </tr>
                        <tr id="height10px"></tr>
                      </thead>
                      <tbody>
                        {allAnswerValues.map((answers, index) => (
                          <>
                            {answers.rollNos
                              .filter(
                                (item) => item.previousRollNo !== item.rollNo
                              )
                              .map((answer, index) => (
                                <tr key={index} id="height10px">
                                  <td id="bordered">{answer.centerName}</td>
                                  <td id="bordered">{answer.bookletNo}</td>
                                  <td id="bordered">{answer.sheetNo}</td>
                                  <td id="bordered">{answer.previousRollNo}</td>
                                  <td id="bordered">{answer.rollNo}</td>
                                </tr>
                              ))}
                            <tr id="height10px"></tr>
                          </>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                ""
              )}
              <hr></hr>
            </div>
            <div className="col-md-4">
              <div className="card">
                <div className="card-header">
                  {label.APPROVAL} (
                  {selectedEntity &&
                  selectedEntity.entityApprovalAction.level == 1
                    ? label.APPROVAL_LEVEL_1_PENDING
                    : ""}
                  {selectedEntity &&
                  selectedEntity.entityApprovalAction.level == 2
                    ? label.APPROVAL_LEVEL_2_PENDING
                    : ""}
                  {selectedEntity &&
                  selectedEntity.entityApprovalAction.level == 3
                    ? label.APPROVAL_LEVEL_3_PENDING
                    : ""}
                  )
                </div>
                <div
                  className={`card-body ${
                    selectedEntity &&
                    selectedEntity.entityApprovalAction.actionLabel ==
                      "Approved"
                      ? "disabled-link"
                      : ""
                  }`}
                >
                  <label className="bold-label">{label.ACTION}</label>
                  &nbsp;&nbsp;
                  <h6>
                    {selectedEntity &&
                      selectedEntity.entityApprovalAction.entityApprovalDto
                        .approvalTypeLabel}
                  </h6>
                  <br />
                  <h6 className="bold-label">
                    {label.STATUS}
                    <span className="redColor">*</span>
                  </h6>
                  <div className="col-md-12 radio-group">
                    <label className="radio-label">
                      <input
                        type="radio"
                        className="radio"
                        name="statustype"
                        value="1"
                        ref={register({ required: true })}
                      />
                      &nbsp;{label.APPROVE}
                    </label>
                    <label className="radio-label">
                      <input
                        type="radio"
                        className="radio"
                        name="statustype"
                        value="2"
                        ref={register({ required: true })}
                      />
                      &nbsp;{label.REJECT}
                    </label>
                  </div>
                  {watch("statustype") == "2" ? (
                    <>
                      <h6 className="bold-label">
                        {label.COMMENTS}
                        <span className="redColor">*</span>
                      </h6>
                      <div className="top-padding">
                        <h6>
                          <input
                            type="text"
                            className="form-control"
                            name="comment"
                            maxLength={255}
                            placeholder={clabel.ENTER_TEXT_UPTO_255_CHARACTERS}
                            ref={register({
                              required: true,
                              pattern: {
                                value: /^(?!\s+$)/,
                              },
                            })}
                          />
                        </h6>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="top-padding">
                        <h6 className="bold-label">{label.COMMENTS}</h6>
                        <h6>
                          <input
                            type="text"
                            className="form-control"
                            name="comment"
                            maxLength={255}
                            placeholder={clabel.ENTER_TEXT_UPTO_255_CHARACTERS}
                            ref={register({
                              required: false,
                              pattern: {
                                value: /^(?!\s+$)/,
                              },
                            })}
                          />
                        </h6>
                      </div>
                    </>
                  )}
                  <div className="row custom-button justify-content-end">
                    <button
                      className="btn btn-secondary mr-2"
                      type="button"
                      onClick={() => {
                        props.setShowModal(false);
                      }}
                    >
                      {label.CANCEL}
                    </button>
                    <button
                      className="btn btn-primary mr-2"
                      disabled={!formState.isValid}
                      onClick={handleSubmit((e) => {
                        onSubmit(e);
                      })}
                    >
                      {label.SAVE}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </form>
    </Modal>
  );
};
export default DuplicateApprovalEntity;
